import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AlertService from "../../components/SweetAlert";
import ToastUtil from "../../components/ToastNotification/ToastUtil";
import { GET, newFetch, POST } from "../../helpers/fetch";
import UploadArt from "../Input/UploadART";

const ARTUpload = ({ history }) => {
  const { t } = useTranslation();
  const user = JSON.parse(localStorage.getItem("user"));
  const userFirstName = JSON.parse(localStorage.getItem("user")).first_name;
  const userLastName = JSON.parse(localStorage.getItem("user")).last_name;
  const asscoiateId = JSON.parse(localStorage.getItem("user")).id;

  const [mobile, setMobile] = useState();
  const [test_result, setTestResult] = useState(0);
  const [shift, setShift] = useState();
  const [location, setLocation] = useState();
  const [image, setImage] = useState();
  const [files, setFiles] = useState([]);
  const [submitLabel, setSubmitLabel] = useState("Submit");
  const [disabled, setDisabled] = useState(false);

  const fetchSchedule = async () => {
    let api_path = `/associate/myschedule`;
    let response = await newFetch(GET, api_path);
    if (response.success) {
      let data = response.data;
      const today = moment().format("DD/MM/YYYY");
      let shiftString = today + ", ";
      let hasShift = false;
      data.forEach((e) => {
        if (e.date == moment().format("YYYY-MM-DD")) {
          e.start_time = `${moment().format("YYYY-MM-DD")} ${e.start_time}`;
          e.end_time = `${moment().format("YYYY-MM-DD")} ${e.end_time}`;
          let newConcat =
            e.shift +
            "(" +
            moment(e.start_time).format("LT") +
            "-" +
            moment(e.end_time).format("LT") +
            "), ";
          shiftString = shiftString.concat(newConcat);
          hasShift = true;
        }
      });
      if (!hasShift) {
        shiftString = shiftString.concat(" No scheduled shift today.");
      }

      setShift(shiftString);
    }
  };

  const handleValidation = () => {
    if (!test_result) {
      ToastUtil.error("Please select Test Result!");
      return false;
    }

    return true;
  };

  useEffect(() => {
    fetchSchedule();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      handleValidation() &&
      (await AlertService.confirm(
        "",
        "Are you sure you want to submit your ART Results?"
      ))
    ) {
      setSubmitLabel("Submitting...");
      setDisabled(true);
      let formData = new FormData();
      formData.append("mobile", mobile);
      formData.append("location", location);
      formData.append("shift", shift);
      formData.append("result", test_result);
      for (let file of files) {
        formData.append("image", file);
      }
      let api_path = `/associate/art/add`;
      let response = await newFetch(POST, api_path, formData, "multi");
      ToastUtil.success(response.message);
      if (response.success) {
        window.location.reload(false);
        // setLocation('')
        // setFiles([])
      } else {
        setSubmitLabel("Submit");
        setDisabled(false);
      }
    }
  };

  return (
    <form className="form" onSubmit={(e) => handleSubmit(e)}>
      <div className="d-flex flex-column my-3">
        <div className="form-group">
          <label htmlFor="userName" className="text-bold">
            {t("Name")}
          </label>
          <p>{userFirstName + " " + userLastName}</p>
        </div>

        <div className="form-group">
          <label htmlFor="mobile" className="text-bold">
            {t("Mobile Number")}
          </label>
          <input
            type="text"
            id="mobile"
            name="mobile"
            className="form-control"
            placeholder=""
            value={mobile}
            onChange={({ target: { value } }) => setMobile(value)}
          />
        </div>
        <div className="form-group">
          <label htmlFor="shift" className="text-bold">
            {t("Shift Details")}
          </label>
          <p>{shift}</p>
        </div>
        <div className="form-group">
          <label htmlFor="feedbackUpload" className="text-bold">
            {t("Upload File")} *<span className="text-muted"></span>
          </label>
          <UploadArt files={files} setFiles={setFiles} />
        </div>
        <div className="form-group">
          <label htmlFor="test_result" className="text-bold">
            {t("Test Result")} *
          </label>
          <select
            type="text"
            id="test_result"
            name="test_result"
            className="form-select"
            placeholder=""
            value={test_result}
            onChange={({ target: { value } }) => setTestResult(value)}
          >
            <option disabled value="0">
              {t("Select Test Result")}
            </option>
            <option value="Negative">{t("Negative")}</option>
            <option value="Positive">{t("Positive")}</option>
          </select>
        </div>
        <button className="btn btn-brand btn-block" disabled={disabled}>
          {submitLabel}
        </button>
      </div>
    </form>
  );
};

export default ARTUpload;
